import { render, staticRenderFns } from "./SliceAnnouncement.vue?vue&type=template&id=6bd245e8&lang=pug&"
import script from "./SliceAnnouncement.vue?vue&type=script&lang=js&"
export * from "./SliceAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports